/**
 * Svelte action: рендерить тултіп у document.body (position:fixed).
 * Не залежить від overflow:hidden батьківських контейнерів.
 *
 * Використання:
 *   <span use:tooltip={() => 'текст підказки'}>...</span>
 */
export function tooltip(node: HTMLElement, getText: () => string) {
    let el: HTMLDivElement | null = null;

    function show(e: MouseEvent) {
        el = document.createElement('div');
        el.className = '__ind-tooltip';
        el.textContent = getText();
        document.body.appendChild(el);
        move(e);
    }

    function move(e: MouseEvent) {
        if (!el) return;
        const tw = el.offsetWidth;
        const th = el.offsetHeight;
        let x = e.clientX - tw / 2;
        let y = e.clientY - th - 14;
        x = Math.max(8, Math.min(x, window.innerWidth  - tw - 8));
        y = Math.max(8, Math.min(y, window.innerHeight - th - 8));
        el.style.left = `${x}px`;
        el.style.top  = `${y}px`;
    }

    function hide() {
        el?.remove();
        el = null;
    }

    node.addEventListener('mouseenter', show);
    node.addEventListener('mousemove',  move);
    node.addEventListener('mouseleave', hide);

    return {
        update(newGet: () => string) { getText = newGet; },
        destroy() {
            hide();
            node.removeEventListener('mouseenter', show);
            node.removeEventListener('mousemove',  move);
            node.removeEventListener('mouseleave', hide);
        },
    };
}
